<template>
  <main
    v-if="localActive"
    id="modal-id"
    class="modal modal-md active"
  >
    <a class="modal-overlay" aria-label="Close"></a>

    <div class="modal-container">
      <div class="modal-header">
        <!-- <a @click="close()" class="btn btn-clear float-right" aria-label="Close"></a> -->
        <div class="modal-title h5">
          Atualize sua senha
        </div>
      </div>

      <div class="modal-body">
        <p>
          Sua senha não é atualizada há seis meses, para sua segurança,
          você precisa atualizar sua senha agora.
        </p>

        <form class="columns" @submit.prevent="submit()">
          <dr-field
            v-for="(field, name) in formData"
            :key="'main_'+name"
            :ref="name"
            :id="name"
            :form.sync="formData"
            :field.sync="field"
            :value.sync="formData[name].value"
            :validators.sync="$v.formData[name]"
            :apiErrors.sync="apiErrors[name]"
            prefix="form1"
            class="text-left"
          />

          <span class="col-12">
            <dr-submit
              :disabled="$v.$invalid"
              :sending="sending"
              text="Salvar"
            />
          </span>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import { formData, validations } from '@/data/formData/userPassword'

export default {
  props: ['nextRoute'],
  components: {
    drField,
    drSubmit
  },
  data () {
    return {
      loaded: false,
      formData: formData,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      sending: false,
      localActive: true
    }
  },
  validations: {
    formData: validations
  },
  created () {
    for (let field in this.formData) {
      if (field === 'currentPassword') {
        this.formData[field].offset = 6
      }
      this.formData[field].size = 6
      this.formData[field].value = null
    }
  },
  methods: {
    close () {
      this.localActive = false
      this.$emit('cancel', true)
    },
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const data = this.fn_EXPAND_OBJECT(this.formData)

      this.sending = true
      this.fn_SHOW_PROGRESS()
      this.$http
        .put(
          '/doctor/password',
          { 'password': data },
          this.$store.getters.getAuthHeader
        )
        .then((res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Senha alterada com sucesso',
            size: 'md',
            active: true,
            callback: () => this.$router.go(`/${this.nextRoute}`)
          })

          for (let field in this.formData) {
            this.formData[field].value = null
          }

          this.$v.$reset()
          this.localActive = false
        })
        .catch((err) => {
          console.log(err)
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children)
              .then((res) => {
                let errs = []

                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                  errs.push(res[field])
                }

                this.$store.dispatch('setModalAlert', {
                  title: 'Erro',
                  body: errs.join('\n'),
                  size: 'md',
                  active: true
                })
              })
          } else {
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }
        })
        .finally(() => {
          this.sending = false
          this.fn_HIDE_PROGRESS()
        })
    }
  }
}
</script>
